import React from 'react'

import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './mobile-application-security.css'

const MobileApplicationSecurity = (props) => {
  return (
    <div className="mobile-application-security-container">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Mobile-Application-Security - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/mobile-application-security"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="mobile-security-hero">
        <div className="hero-container">
          <div className="contact-us-hero-content-wrapper">
            <div className="hero-text-content">
              <h1 className="hero-title">
                Mobile Application Security Testing
              </h1>
              <p className="hero-subtitle">
                Comprehensive Android &amp; iOS security assessments that
                identify vulnerabilities before attackers do. Protect your
                mobile applications with enterprise-grade penetration testing
                and security validation.
              </p>
              <div className="hero-cta-group contact-us-hero-cta-group">
                <button className="btn-primary btn btn-lg">
                  Request Security Assessment
                </button>
                <button className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>View Methodology</span>
                </button>
              </div>
            </div>
            <div className="hero-visual">
              <img
                alt="Close-up of a finger entering a passcode on a smartphone security screen."
                src="https://images.pexels.com/photos/27742642/pexels-photo-27742642.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              />
            </div>
          </div>
        </div>
        <section className="platform-selector">
          <div className="platform-container">
            <div className="android-card platform-card">
              <div className="platform-icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="5"
                      y="2"
                      rx="2"
                      ry="2"
                      width="14"
                      height="20"
                    ></rect>
                    <path d="M12 18h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Android Security</h3>
              <p className="section-content">
                APK analysis, reverse engineering, and comprehensive Android
                vulnerability assessment
              </p>
            </div>
            <div className="ios-card platform-card">
              <div className="platform-icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="5"
                      y="2"
                      rx="2"
                      ry="2"
                      width="14"
                      height="20"
                    ></rect>
                    <path d="M12 18h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">iOS Security</h3>
              <p className="section-content">
                IPA decryption, binary analysis, and comprehensive iOS security
                validation
              </p>
            </div>
          </div>
        </section>
        <section className="android-security-section">
          <div className="section-header-container">
            <div className="section-badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span>Android Platform</span>
            </div>
            <h2 className="section-title">Android Security Testing Services</h2>
            <p className="section-subtitle">
              Comprehensive security assessment for Android applications
              covering APK analysis, reverse engineering, and runtime protection
              validation
            </p>
          </div>
          <div className="android-content-grid">
            <div className="android-feature-card">
              <div className="contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m13 13.5l2-2.5l-2-2.5M21 21l-4.3-4.3M9 8.5L7 11l2 2.5"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                APK Analysis &amp; Reverse Engineering
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>Static APK analysis and decompilation</span>
                </li>
                <li className="feature-item">
                  <span>DEX file extraction and bytecode review</span>
                </li>
                <li className="feature-item">
                  <span>Resource and manifest file analysis</span>
                </li>
                <li className="feature-item">
                  <span>Third-party library vulnerability assessment</span>
                </li>
                <li className="feature-item">
                  <span>Code obfuscation effectiveness testing</span>
                </li>
              </ul>
            </div>
            <div className="android-feature-card">
              <div className="contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                Bytecode &amp; Decompilation Analysis
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>SMALI code review and analysis</span>
                </li>
                <li className="feature-item">
                  <span>Java decompilation with JD-GUI and JADX</span>
                </li>
                <li className="feature-item">
                  <span>Native library (SO files) inspection</span>
                </li>
                <li className="feature-item">
                  <span>Logic flow and authentication mechanism review</span>
                </li>
                <li className="feature-item">
                  <span>Hardcoded credential detection</span>
                </li>
              </ul>
            </div>
            <div className="android-feature-card">
              <div className="contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                Data Storage Security
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>SharedPreferences encryption validation</span>
                </li>
                <li className="feature-item">
                  <span>SQLite database security assessment</span>
                </li>
                <li className="feature-item">
                  <span>Internal storage protection testing</span>
                </li>
                <li className="feature-item">
                  <span>External storage security evaluation</span>
                </li>
                <li className="feature-item">
                  <span>Keystore implementation review</span>
                </li>
              </ul>
            </div>
            <div className="android-feature-card">
              <div className="contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                Network Communication Security
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>SSL/TLS implementation testing</span>
                </li>
                <li className="feature-item">
                  <span>Certificate pinning validation</span>
                </li>
                <li className="feature-item">
                  <span>Man-in-the-Middle attack simulation</span>
                </li>
                <li className="feature-item">
                  <span>API endpoint security assessment</span>
                </li>
                <li className="feature-item">
                  <span>WebSocket and data transmission analysis</span>
                </li>
              </ul>
            </div>
            <div className="android-feature-card">
              <div className="contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2zm3-12h6m-3 3V7M9 17h6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                Manifest &amp; Permission Analysis
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>AndroidManifest.xml security review</span>
                </li>
                <li className="feature-item">
                  <span>Permission over-privilege detection</span>
                </li>
                <li className="feature-item">
                  <span>Exported component identification</span>
                </li>
                <li className="feature-item">
                  <span>Intent filter vulnerability assessment</span>
                </li>
                <li className="feature-item">
                  <span>Backup and debug flag validation</span>
                </li>
              </ul>
            </div>
            <div className="android-feature-card">
              <div className="contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                Common Android Vulnerabilities
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>Insecure data storage exploitation</span>
                </li>
                <li className="feature-item">
                  <span>Exported component abuse testing</span>
                </li>
                <li className="feature-item">
                  <span>WebView implementation vulnerabilities</span>
                </li>
                <li className="feature-item">
                  <span>Insecure IPC mechanisms</span>
                </li>
                <li className="feature-item">
                  <span>Root detection bypass techniques</span>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="ios-security-section">
          <div className="section-header-container">
            <div className="section-badge ios-badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span>iOS Platform</span>
            </div>
            <h2 className="section-title">iOS Security Testing Services</h2>
            <p className="section-subtitle">
              Expert iOS security assessment covering IPA analysis, binary
              inspection, and comprehensive security validation for iPhone and
              iPad applications
            </p>
          </div>
          <div className="ios-content-grid">
            <div className="ios-feature-card">
              <div className="ios-icon contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m13 13.5l2-2.5l-2-2.5M21 21l-4.3-4.3M9 8.5L7 11l2 2.5"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                IPA Analysis &amp; Decryption
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>IPA file extraction and analysis</span>
                </li>
                <li className="feature-item">
                  <span>FairPlay DRM decryption techniques</span>
                </li>
                <li className="feature-item">
                  <span>Application binary inspection</span>
                </li>
                <li className="feature-item">
                  <span>Framework and library assessment</span>
                </li>
                <li className="feature-item">
                  <span>Code signature validation testing</span>
                </li>
              </ul>
            </div>
            <div className="ios-feature-card">
              <div className="ios-icon contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                Binary Code Review &amp; Dynamic Analysis
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>Mach-O binary structure analysis</span>
                </li>
                <li className="feature-item">
                  <span>Objective-C and Swift code review</span>
                </li>
                <li className="feature-item">
                  <span>Runtime manipulation with Frida</span>
                </li>
                <li className="feature-item">
                  <span>Method swizzling detection</span>
                </li>
                <li className="feature-item">
                  <span>Dynamic instrumentation testing</span>
                </li>
              </ul>
            </div>
            <div className="ios-feature-card">
              <div className="ios-icon contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="1" cx="12" cy="16"></circle>
                    <rect x="3" y="10" rx="2" width="18" height="12"></rect>
                    <path d="M7 10V7a5 5 0 0 1 10 0v3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                Keychain Security Testing
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>Keychain implementation review</span>
                </li>
                <li className="feature-item">
                  <span>Access control list validation</span>
                </li>
                <li className="feature-item">
                  <span>Data protection class assessment</span>
                </li>
                <li className="feature-item">
                  <span>Keychain item extraction testing</span>
                </li>
                <li className="feature-item">
                  <span>Secure enclave usage validation</span>
                </li>
              </ul>
            </div>
            <div className="ios-feature-card">
              <div className="ios-icon contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                Data Protection API Compliance
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>NSFileProtection attribute validation</span>
                </li>
                <li className="feature-item">
                  <span>Data protection class implementation</span>
                </li>
                <li className="feature-item">
                  <span>Core Data encryption assessment</span>
                </li>
                <li className="feature-item">
                  <span>UserDefaults security review</span>
                </li>
                <li className="feature-item">
                  <span>Plist file encryption validation</span>
                </li>
              </ul>
            </div>
            <div className="ios-feature-card">
              <div className="ios-icon contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8 9V2"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                Jailbreak Detection &amp; Bypass
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>Jailbreak detection mechanism testing</span>
                </li>
                <li className="feature-item">
                  <span>Detection bypass technique validation</span>
                </li>
                <li className="feature-item">
                  <span>Cydia and package manager detection</span>
                </li>
                <li className="feature-item">
                  <span>File system integrity checks</span>
                </li>
                <li className="feature-item">
                  <span>Runtime environment validation</span>
                </li>
              </ul>
            </div>
            <div className="ios-feature-card">
              <div className="ios-icon contact-us-feature-icon1">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="contact-us-feature-title1">
                Runtime Protection &amp; Network Security
              </h3>
              <ul className="feature-list">
                <li className="feature-item">
                  <span>SSL/TLS pinning implementation</span>
                </li>
                <li className="feature-item">
                  <span>Certificate validation testing</span>
                </li>
                <li className="feature-item">
                  <span>App Transport Security (ATS) review</span>
                </li>
                <li className="feature-item">
                  <span>Anti-debugging mechanism validation</span>
                </li>
                <li className="feature-item">
                  <span>Sandbox escape technique testing</span>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="contact-us-methodology-section1">
          <div className="contact-us-methodology-header1">
            <h2 className="section-title">
              Mobile Security Testing Methodology
            </h2>
            <p className="section-subtitle">
              Our structured approach combines automated tools with manual
              expertise to deliver comprehensive mobile security assessments
            </p>
          </div>
          <div className="methodology-timeline">
            <div className="contact-us-timeline-item1">
              <div className="contact-us-timeline-marker1">
                <span className="timeline-number">01</span>
              </div>
              <div className="contact-us-timeline-content1">
                <h3 className="contact-us-timeline-title1">
                  Reconnaissance &amp; Information Gathering
                </h3>
                <p className="section-content">
                  Application profiling, architecture analysis, API endpoint
                  discovery, and threat model development based on business
                  logic and data flows.
                </p>
              </div>
            </div>
            <div className="contact-us-timeline-item1">
              <div className="contact-us-timeline-marker1">
                <span className="timeline-number">02</span>
              </div>
              <div className="contact-us-timeline-content1">
                <h3 className="contact-us-timeline-title1">
                  Static Analysis &amp; Reverse Engineering
                </h3>
                <p className="section-content">
                  Decompilation, bytecode review, manifest/plist analysis,
                  hardcoded credential detection, and third-party library
                  vulnerability assessment.
                </p>
              </div>
            </div>
            <div className="contact-us-timeline-item1">
              <div className="contact-us-timeline-marker1">
                <span className="timeline-number">03</span>
              </div>
              <div className="contact-us-timeline-content1">
                <h3 className="contact-us-timeline-title1">
                  Dynamic Analysis &amp; Runtime Testing
                </h3>
                <p className="section-content">
                  Live application instrumentation, API traffic interception,
                  authentication bypass testing, and runtime manipulation
                  validation.
                </p>
              </div>
            </div>
            <div className="contact-us-timeline-item1">
              <div className="contact-us-timeline-marker1">
                <span className="timeline-number">04</span>
              </div>
              <div className="contact-us-timeline-content1">
                <h3 className="contact-us-timeline-title1">
                  Data Storage &amp; Encryption Validation
                </h3>
                <p className="section-content">
                  Database encryption testing, keychain security review, file
                  system permission analysis, and data leakage assessment.
                </p>
              </div>
            </div>
            <div className="contact-us-timeline-item1">
              <div className="contact-us-timeline-marker1">
                <span className="timeline-number">05</span>
              </div>
              <div className="contact-us-timeline-content1">
                <h3 className="contact-us-timeline-title1">
                  Network Security &amp; Communication Testing
                </h3>
                <p className="section-content">
                  SSL/TLS validation, certificate pinning bypass attempts,
                  man-in-the-middle attack simulation, and API security
                  assessment.
                </p>
              </div>
            </div>
            <div className="contact-us-timeline-item1">
              <div className="contact-us-timeline-marker1">
                <span className="timeline-number">06</span>
              </div>
              <div className="contact-us-timeline-content1">
                <h3 className="contact-us-timeline-title1">
                  Reporting &amp; Remediation Guidance
                </h3>
                <p className="section-content">
                  Comprehensive vulnerability report with risk ratings,
                  exploitation scenarios, remediation recommendations, and
                  executive summary.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="tools-section">
          <div className="tools-container">
            <h2 className="section-title">Testing Tools &amp; Frameworks</h2>
            <p className="section-subtitle">
              Industry-leading tools and custom scripts for comprehensive mobile
              security assessment
            </p>
            <div className="tools-grid">
              <div className="tool-category">
                <h3 className="tool-category-title">Android Testing Tools</h3>
                <ul className="tool-list">
                  <li className="tool-item">
                    <span>Apktool - APK decompilation and recompilation</span>
                  </li>
                  <li className="tool-item">
                    <span>JADX - DEX to Java decompiler</span>
                  </li>
                  <li className="tool-item">
                    <span>Frida - Dynamic instrumentation toolkit</span>
                  </li>
                  <li className="tool-item">
                    <span>Objection - Runtime mobile exploration</span>
                  </li>
                  <li className="tool-item">
                    <span>MobSF - Mobile Security Framework</span>
                  </li>
                  <li className="tool-item">
                    <span>ADB - Android Debug Bridge</span>
                  </li>
                  <li className="tool-item">
                    <span>Drozer - Android security assessment framework</span>
                  </li>
                  <li className="tool-item">
                    <span>Burp Suite - Web proxy and security testing</span>
                  </li>
                </ul>
              </div>
              <div className="tool-category">
                <h3 className="tool-category-title">iOS Testing Tools</h3>
                <ul className="tool-list">
                  <li className="tool-item">
                    <span>Frida - Dynamic instrumentation for iOS</span>
                  </li>
                  <li className="tool-item">
                    <span>Objection - iOS runtime manipulation</span>
                  </li>
                  <li className="tool-item">
                    <span>Hopper - Binary disassembler for macOS</span>
                  </li>
                  <li className="tool-item">
                    <span>Class-dump - Objective-C header extraction</span>
                  </li>
                  <li className="tool-item">
                    <span>Cycript - Runtime modification tool</span>
                  </li>
                  <li className="tool-item">
                    <span>iProxy - USB tunneling for jailbroken devices</span>
                  </li>
                  <li className="tool-item">
                    <span>SSL Kill Switch - Certificate pinning bypass</span>
                  </li>
                  <li className="tool-item">
                    <span>MobSF - Comprehensive iOS security analysis</span>
                  </li>
                </ul>
              </div>
              <div className="tool-category">
                <h3 className="tool-category-title">
                  Network &amp; Traffic Analysis
                </h3>
                <ul className="tool-list">
                  <li className="tool-item">
                    <span>
                      Burp Suite Professional - HTTP/HTTPS interception
                    </span>
                  </li>
                  <li className="tool-item">
                    <span>Charles Proxy - SSL proxy and debugging</span>
                  </li>
                  <li className="tool-item">
                    <span>Wireshark - Network protocol analyzer</span>
                  </li>
                  <li className="tool-item">
                    <span>mitmproxy - Man-in-the-middle proxy</span>
                  </li>
                  <li className="tool-item">
                    <span>tcpdump - Command-line packet analyzer</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="contact-us-deliverables-section1">
          <div className="deliverables-container">
            <div className="contact-us-deliverables-header1 deliverables-header">
              <h2 className="section-title">
                Comprehensive Security Deliverables
              </h2>
              <p className="section-subtitle">
                Actionable reports and documentation to strengthen your mobile
                application security posture
              </p>
            </div>
            <div className="deliverables-grid contact-us-deliverables-grid1">
              <div className="contact-us-deliverable-card1">
                <div className="contact-us-deliverable-icon1">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                      <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="contact-us-deliverable-title1">
                  Executive Summary Report
                </h3>
                <p className="section-content">
                  High-level overview of security findings, risk assessment, and
                  business impact analysis for stakeholders and executives.
                </p>
              </div>
              <div className="contact-us-deliverable-card1">
                <div className="contact-us-deliverable-icon1">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                      <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="contact-us-deliverable-title1">
                  Technical Vulnerability Report
                </h3>
                <p className="section-content">
                  Detailed technical findings with proof-of-concept exploits,
                  severity ratings (CVSS), affected components, and exploitation
                  steps.
                </p>
              </div>
              <div className="contact-us-deliverable-card1">
                <div className="contact-us-deliverable-icon1">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"></path>
                      <path d="m9 9.5l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="contact-us-deliverable-title1">
                  Remediation Roadmap
                </h3>
                <p className="section-content">
                  Prioritized remediation guide with actionable recommendations,
                  code samples, and best practices for secure implementation.
                </p>
              </div>
              <div className="contact-us-deliverable-card1">
                <div className="contact-us-deliverable-icon1">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <circle r="6" cx="12" cy="12"></circle>
                      <circle r="2" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
                <h3 className="contact-us-deliverable-title1">
                  OWASP MASVS Compliance Matrix
                </h3>
                <p className="section-content">
                  Mapping of findings to OWASP Mobile Application Security
                  Verification Standard for compliance validation.
                </p>
              </div>
              <div className="contact-us-deliverable-card1">
                <div className="contact-us-deliverable-icon1">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m16 18l6-6l-6-6M8 6l-6 6l6 6"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="contact-us-deliverable-title1">
                  Source Code Analysis Report
                </h3>
                <p className="section-content">
                  Decompiled code review highlighting insecure coding patterns,
                  logic flaws, and hardcoded sensitive information.
                </p>
              </div>
              <div className="contact-us-deliverable-card1">
                <div className="contact-us-deliverable-icon1">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="contact-us-deliverable-title1">
                  Retest &amp; Validation Report
                </h3>
                <p className="section-content">
                  Post-remediation testing to validate fixes, verify security
                  controls, and confirm vulnerability resolution.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="contact-us-compliance-section1">
          <div className="contact-us-compliance-container1">
            <h2 className="section-title">
              Compliance Standards &amp; Frameworks
            </h2>
            <p className="section-subtitle">
              Our mobile security testing aligns with international security
              standards and best practices
            </p>
            <div className="contact-us-compliance-grid1">
              <div className="contact-us-compliance-card1">
                <div className="compliance-logo">
                  <svg
                    width="36"
                    xmlns="http://www.w3.org/2000/svg"
                    height="36"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="compliance-title">OWASP Mobile Top 10</h3>
                <p className="section-content">
                  Testing methodology aligned with OWASP Mobile Top 10 risk
                  categories and MASVS verification levels.
                </p>
              </div>
              <div className="contact-us-compliance-card1">
                <div className="compliance-logo">
                  <svg
                    width="36"
                    xmlns="http://www.w3.org/2000/svg"
                    height="36"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9 12l2 2l4-4"></path>
                      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="compliance-title">ISO 27001</h3>
                <p className="section-content">
                  Security controls and testing procedures compliant with ISO
                  27001 information security management standards.
                </p>
              </div>
              <div className="contact-us-compliance-card1">
                <div className="compliance-logo">
                  <svg
                    width="36"
                    xmlns="http://www.w3.org/2000/svg"
                    height="36"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                      <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="compliance-title">PCI DSS Mobile Guidelines</h3>
                <p className="section-content">
                  Mobile payment application testing aligned with PCI Mobile
                  Payment Acceptance Security Guidelines.
                </p>
              </div>
              <div className="contact-us-compliance-card1">
                <div className="compliance-logo">
                  <svg
                    width="36"
                    xmlns="http://www.w3.org/2000/svg"
                    height="36"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="3"
                        y="11"
                        rx="2"
                        ry="2"
                        width="18"
                        height="11"
                      ></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="compliance-title">GDPR &amp; Data Protection</h3>
                <p className="section-content">
                  Privacy assessment ensuring compliance with GDPR, CCPA, and
                  regional data protection regulations.
                </p>
              </div>
              <div className="contact-us-compliance-card1">
                <div className="compliance-logo">
                  <svg
                    width="36"
                    xmlns="http://www.w3.org/2000/svg"
                    height="36"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="8" cx="11" cy="11"></circle>
                      <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="compliance-title">
                  NIST Cybersecurity Framework
                </h3>
                <p className="section-content">
                  Security testing methodology following NIST SP 800-163 and
                  mobile-specific security guidelines.
                </p>
              </div>
              <div className="contact-us-compliance-card1">
                <div className="compliance-logo">
                  <svg
                    width="36"
                    xmlns="http://www.w3.org/2000/svg"
                    height="36"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8 9V2"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="compliance-title">OWASP MASVS</h3>
                <p className="section-content">
                  Comprehensive testing against Mobile Application Security
                  Verification Standard levels L1, L2, and R.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="cta-section contact-us-cta-section1">
          <div className="mobile-application-security-thq-cta-overlay-elm contact-us-cta-overlay1"></div>
          <div className="contact-us-cta-content1">
            <h2 className="hero-title">
              Secure Your Mobile Applications Today
            </h2>
            <p className="hero-subtitle">
              Partner with our expert security team to identify and remediate
              mobile vulnerabilities before they become security incidents.
              Comprehensive testing for Android and iOS platforms.
            </p>
            <div className="cta-button-group">
              <button className="btn-primary btn-xl btn">
                Schedule Security Assessment
              </button>
            </div>
          </div>
        </section>
      </section>
      <Footer></Footer>
    </div>
  )
}

export default MobileApplicationSecurity
